import Service from './Service';
import {SERVER_URL} from "../utils/Constants";
import GeneralUtils from "../utils/GeneralUtils";

export default class TtRegionService extends Service{
    constructor() {
        super();
        this.baseURL = 'ttRegion';
    }

    findTtRegionByCityId(cityId) {
        return fetch(SERVER_URL + this.baseURL + '/' + cityId, {
            headers: {'Content-Type': 'application/json', Authorization: localStorage.getItem("Authorization")}
        }).then(response => response.json()).catch(error => {
            GeneralUtils.notification(error);
        });
    }

}